// extracted by mini-css-extract-plugin
export var layoutContainer = "Layout_layoutContainer__HOrtJ";